import { omit } from 'lodash-es';
import { v4 as uuidV4 } from 'uuid';
import type { HubProgressBar } from 'dorian-shared/types/branch/HubOption';
import {
  registerHubSettingsDeserializer,
  registerHubSettingsSerializer,
} from './hubSerialize';

// Self-registering module: imported for side effects from hubOptionTransform.ts.
// Adding a new hub-settings field is a new file here, not an edit of existing code.

registerHubSettingsDeserializer((settings) => {
  if (!settings.progressBars) return;
  // eslint-disable-next-line no-param-reassign -- match in-place mutation style of hubOptionTransform.ts
  settings.progressBars = settings.progressBars
    // Truthy check, not nullish — empty string is not a valid React/DnD key.
    .map((bar): HubProgressBar => ({
      ...bar,
      uuid: bar.uuid || uuidV4(),
      numeratorUuid: bar.numeratorUuid || uuidV4(),
      denominatorUuid: bar.denominatorUuid || uuidV4(),
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder);
});

registerHubSettingsSerializer((settings) => {
  if (!settings.progressBars) return;
  // uuid / numeratorUuid / denominatorUuid are UI-only; backend columns don't exist.
  // eslint-disable-next-line no-param-reassign -- match in-place mutation style of hubOptionTransform.ts
  settings.progressBars = settings.progressBars.map((bar, index) => ({
    ...omit(bar, ['uuid', 'numeratorUuid', 'denominatorUuid']),
    sortOrder: index,
  } as HubProgressBar));
});
